<template>
  <div :class="$style['news-page-m']">
    <div :class="$style['news-page-header']">
      <p :class="$style['header-title']">新闻动态</p>
      <img src="@/assets/img/news/News.png" :class="$style['title-lable']" />
      <!-- <p :class="$style['title-lable']">News</p> -->
      <img src="@/assets/img/news/news-header.png" :class="$style['header-img']"/>
    </div>
    <div :class="$style['news-page-dynamic']">
      <div :class="$style['dynamic-header']">

        <div :class="$style['header-line']"></div>
        <div :class="$style['header-title']">最新动态</div>
      </div>
      <div :class="$style['dynamic-list']">
        <div :class="$style['list-item']" @click.stop="handleDetail(item)" v-for="item in list" :key="item.id">
          <ArticleImage
            :class="$style['item-img']"
            :src="item.article_cover"
            :info="item.article_cover_point"
            :width="135"
            :height="76"
          />
          <div :class="$style['item-desc']">
            <p :class="$style['desc-title']">{{item.article_title}}</p>
            <p :class="$style['desc-time']">{{item.time}}</p>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style['btn-footer']">
      <p :class="$style['btn-action']" @click.stop="loadingMore" v-if="hasMore">加载更多新闻</p>
      <p :class="$style['btn-desc']" v-else>到底了</p>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import NewsService from '@/service/news.service.js'
import ArticleImage from './ArticleImage.vue'
export default {
  name: '',
  components: {
    ArticleImage
  },
  props: {
  // visible: VueTypes.bool.def(false)
  },
  data () {
    return {
      page: 1,
      size: 10,
      list: [],
      hasMore: false
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    this.getCount()
  },
  watch: {
  },
  methods: {
    // 获取文章置顶数量
    getCount () {
      const postData = {
        offset: this.page - 1,
        size: this.size
      }
      NewsService.getGeekbangList(postData)
      .then(data => {
        this.list = this.list.concat(data.list)
        this.hasMore = data.hasMore
        console.log(data)
      })
      .catch(() => {})
    },
    loadingMore () {
      this.page++
      this.getCount()
    },
    handleDetail (item) {
      sensors.track('click_general', {
        page_name: '官网新闻页面',
        button_name: item.article_title
      })
      if (item.type === 1) {
        const link = item.sub_type === 4 ? `${config.infoq}/news/${item.uuid}` : `${config.infoq}/article/${item.uuid}`
        location.href = link
      }
    }
  }
}
</script>
<style lang='scss' module>
.news-page-m {
  padding-bottom: 50px;
  & .news-page-header {
    box-sizing: border-box;
    width: 100%;
    height: 300px;
    padding-top: 40px;
    background: linear-gradient(180deg, #FFF0D7 0%, #FFFFFF 100%);
    text-align: center;

    & .header-title {
      font-size: 30px;
      font-weight: 600;
      color: #404040;
      letter-spacing: 3px;
    }

    & .title-lable {
      width: 48px;
      margin: 5px auto 20px;
    }

    & .header-img {
      width: 218px; height: 160px;
      margin: 0 auto;
    }
  }
  & .news-page-dynamic {
    padding: 40px 30px 30px;

    & .dynamic-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      & .header-title {
        font-size: 18px;
        font-weight: 500;
        color: #404040;
        margin-left: 10px;
      }
      & .header-line {
        width: 2px;
        height: 14px;
        background: #FA6400;
        border-radius: 4px;

      }
    }
    & .dynamic-list {
      margin-top: 17px;
      & .list-item {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 20px;
        & .item-img {
          border-radius: 4px;
          margin-right: 12px;
        }
        & .item-desc {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          & .desc-title {
            display: -webkit-box;
            -webkit-box-orient: vertical;  //上下垂直
            -webkit-line-clamp: 2;  //自定义行数
            width: 100%;
            line-height: 21px;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 15px;
            font-weight: 500;
            color: #404040;
          }
          & .desc-time {
            margin-top: 8px;
            font-size: 12px;
            font-weight: 400;
            color: #7F848C;
          }
        }
      }
    }
  }
  .btn-footer {
    // margin-top: 30px;
    text-align: center;
    & .btn-action {
      width: 220px;
      height: 42px;
      line-height: 42px;
      background: linear-gradient(315deg, #FFD492 0%, #FA8919 100%);
      border-radius: 21px;
      margin: 0 auto;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #FFFFFF;
    }
    & .btn-desc {
      margin-top: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #888888;
    }
  }

}

</style>
